import { Component } from '@angular/core';
import { AuthenticationService } from './../services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AngularDelegate, ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-announcement',
  templateUrl: 'announcement.page.html',
  styleUrls: ['announcement.page.scss']
})
export class AnnouncementPage {

  announcement: any=[];

  constructor(private route: ActivatedRoute, private authService: AuthenticationService, private loadingController: LoadingController, private modalController: ModalController, navParams: NavParams) {

    let announcement = navParams.get('announcement');
    this.announcement.ready = false;
    this.loadAnnouncement(announcement);
    
  }

  submitReceipt() {
  
    this.authService.postToEndpoint('announcements/'+this.announcement.id+'/receiptconfirm').subscribe(data => {
    this.announcement.receiptstate = true;
   })
  
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }
  
  async loadAnnouncement(announcement) {

      const loading =  await this.loadingController.create({
        message: "Lade Inhalt...",
      });

      await loading.present();
      this.authService.getFromEndpoint('announcements/'+announcement.id).subscribe(data => {
      this.announcement = data;

      this.announcement.ready = true;
      loading.dismiss();
    })
  }

}
